import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("web-tree-sitter");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
export const CaptureQuantifier = _m["CaptureQuantifier"];
export const Edit = _m["Edit"];
export const LANGUAGE_VERSION = _m["LANGUAGE_VERSION"];
export const Language = _m["Language"];
export const LookaheadIterator = _m["LookaheadIterator"];
export const MIN_COMPATIBLE_VERSION = _m["MIN_COMPATIBLE_VERSION"];
export const Node = _m["Node"];
export const Parser = _m["Parser"];
export const Query = _m["Query"];
export const Tree = _m["Tree"];
export const TreeCursor = _m["TreeCursor"];